import React, { useEffect, useState } from "react";
import HRHeader from "../components/HRHeader";
import api from "../api";
import { toast } from "sonner";
import { GraduationCap, Clock, Users, Check, BookOpen } from "lucide-react";

const CAT_COLORS = { Obbligatorio: "#e30613", Digitale: "#0d6cb8", "Soft Skills": "#8e44ad", Formazione: "#009640" };

const FormazionePage = () => {
  const [courses, setCourses] = useState([]);

  const load = () => api.get("/courses").then((r) => setCourses(r.data)).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const toggle = async (c) => {
    try {
      if (c.is_enrolled) {
        await api.delete(`/courses/${c.id}/enroll`);
        toast.success("Iscrizione annullata");
      } else {
        await api.post(`/courses/${c.id}/enroll`);
        toast.success("Iscrizione confermata!");
      }
      load();
    } catch (err) { toast.error(err?.response?.data?.detail || "Errore"); }
  };

  const enrolledCount = courses.filter((c) => c.is_enrolled).length;

  return (
    <div className="min-h-screen bg-[#f0f2f5]" data-testid="formazione-page">
      <HRHeader />
      <main className="max-w-[1200px] mx-auto px-4 py-8">
        <h1 className="text-[26px] font-black text-[#16345c] mb-1 flex items-center gap-2"><GraduationCap size={24} /> Formazione</h1>
        <p className="text-[14px] text-gray-500 mb-6">Corsi e percorsi formativi del gruppo Teleborsa. Sei iscritto a {enrolledCount} {enrolledCount === 1 ? "corso" : "corsi"}.</p>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4" data-testid="courses-grid">
          {courses.map((c) => {
            const color = CAT_COLORS[c.category] || "#16345c";
            return (
              <div key={c.id} className="bg-white border border-gray-200 rounded-lg p-5 flex flex-col">
                <div className="flex items-center justify-between mb-3">
                  <span className="text-[10px] font-black uppercase tracking-wide px-2 py-0.5 rounded-full text-white" style={{ backgroundColor: color }}>{c.category}</span>
                  <span className="text-[11px] font-semibold text-gray-400">{c.level}</span>
                </div>
                <span className="w-11 h-11 rounded-lg flex items-center justify-center mb-3" style={{ backgroundColor: `${color}1a`, color }}><BookOpen size={22} /></span>
                <h3 className="text-[15px] font-bold text-[#16345c] leading-snug mb-1">{c.title}</h3>
                <p className="text-[13px] text-gray-500 leading-relaxed flex-1">{c.description}</p>
                <div className="flex items-center gap-4 text-[12px] text-gray-500 mt-3 mb-3">
                  <span className="flex items-center gap-1"><Clock size={13} /> {c.duration_hours}h</span>
                  <span className="flex items-center gap-1"><Users size={13} /> {c.enrolled_count} iscritti</span>
                </div>
                <button onClick={() => toggle(c)} data-testid={`course-enroll-${c.id}`}
                  className={`w-full flex items-center justify-center gap-1.5 text-[13px] font-bold py-2.5 rounded-sm transition-colors ${c.is_enrolled ? "bg-[#0096401a] text-[#009640] hover:bg-[#00964033]" : "bg-[#16345c] hover:bg-[#0d1b2f] text-white"}`}>
                  {c.is_enrolled ? <><Check size={15} /> Iscritto</> : "Iscriviti"}
                </button>
              </div>
            );
          })}
        </div>
      </main>
    </div>
  );
};

export default FormazionePage;
